import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CampaignService, StorageService, StyleService} from '../_services';
import {PreviewFormComponent} from '../preview';
import {FormBuilder} from '@angular/forms';

@Component({
  moduleId: module.id.toString(),
  selector: 'style-preview-form',
  templateUrl: '../preview/preview-form.component.html',
  styleUrls: ['../preview/preview-form.component.scss', ],
})
export class StylePreviewFormComponent extends PreviewFormComponent implements OnInit {
  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected formBuilder: FormBuilder,
              protected styleService: StyleService,
              protected alertService: AlertService,
              protected campaignService: CampaignService,
              protected storageService: StorageService
  ) {
    super(router, location, route, formBuilder, styleService, alertService, campaignService, storageService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
